import React from "react";
import { MenuStyleMode } from "../constants/uiConstants";
import { TopMenu } from "./TopMenu";

export interface Props {
  menuStyleMode?: MenuStyleMode
}

export const AsideMenu = ({ menuStyleMode }: Props): JSX.Element => {
  if (MenuStyleMode.Docking === menuStyleMode) {
    return (
      <aside>
        <TopMenu
          menuStyleMode={menuStyleMode}
        />
      </aside>
    );
  }
  return <aside><div /></aside>;
};
